import { cn } from '@/utils';
import type { PartGridItem } from '../avatarDecorate.logic';
export const AvatarItemGrid = ({
  items,
  selectedShapeId,
  onSelect
}: {
  items: PartGridItem[];
  selectedShapeId: number | null;
  onSelect: (id: number) => void;
}) => {
  return <ul className="grid grid-cols-4 gap-[10px]" data-sentry-component="AvatarItemGrid" data-sentry-source-file="AvatarItemGrid.tsx">
      {items.map(({
      id,
      shapeId,
      pathName,
      isNew,
      isHot
    }) => {
      const isActive = shapeId === selectedShapeId;
      return <li key={pathName} onClick={() => onSelect(id)} className={cn('relative h-0 cursor-pointer overflow-hidden rounded-[4px] border border-black/[0.08] bg-white pb-[98.7%]', isActive ? 'bg-violet-50 shadow-[inset_0_0_0_2px_theme(colors.violet.500)]' : 'hover:bg-gray-50')}>
            <img src={pathName} alt="avatar part" loading="lazy" className="absolute left-1/2 top-[calc(50%+3px)] w-full -translate-x-1/2 -translate-y-1/2" />
            {(isNew || isHot) && <div className="absolute left-[2px] top-[2px] z-[1] flex gap-[2px]">
                {isNew && <span className="rounded-[10px] bg-strong-default px-[5px] py-[1px] text-[9px] font-bold leading-[1.2] text-white">
                    NEW
                  </span>}
                {isHot && <span className="rounded-[10px] bg-[#ff5252] px-[5px] py-[1px] text-[9px] font-bold leading-[1.2] text-white">
                    HOT
                  </span>}
              </div>}
          </li>;
    })}
    </ul>;
};